import TooltipTemplate from '../../html/components/tooltip.html'
import TooltipToggleTemplate from '../../html/components/tooltip-toggle.html'

import {inert} from '../shared/directives'
import Component from '../shared/component'
import Relation, {HasOne, MemberOf} from '../shared/mixins/relation'
import {PopperMixin, PopperToggleMixin} from '../shared/mixins/popper'

const tooltipToggle = Relation()

/**
 * The ammount of time to wait before showing tooltips.
 */
const DELAY = 1000

export const Tooltip = Component('v-tooltip', {
  mixins: [
    MemberOf(tooltipToggle, 'toggle'),
    PopperMixin('toggle')
  ],
  directives: {
    inert
  },
  template: TooltipTemplate,
  props: {
    tabindex: {
      type: String,
      default: '-1'
    }
  },
  computed: {
    tabindexValue () {
      if (this.tabindex === '') {
        return null
      } else {
        return this.tabindex
      }
    },
    open () {
      const {toggle} = this

      if (toggle) {
        return toggle.open
      }

      return true
    }
  }
})

export const TooltipToggle = Component('v-tooltip-toggle', {
  mixins: [
    HasOne(tooltipToggle, 'tooltip'),
    PopperToggleMixin('tooltip')
  ],
  template: TooltipToggleTemplate,
  props: {
    immediate: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      open: false
    }
  },
  computed: {
    delay () {
      return this.immediate ? 0 : DELAY
    },

    target () {
      const {tooltip} = this

      if (tooltip) {
        return tooltip.id
      }
    },

    active () {
      const {tooltip, open} = this

      if (tooltip) {
        return open
      }
    }
  },
  watch: {
    open: {
      immediate: true,
      handler () {
        if (!this.tooltip) {
          return
        }

        if (this.open) {
          this.pop()
        } else {
          this.unpop()
        }
      }
    }
  },
  methods: {
    show () {
      this.timer = setTimeout(() => {
        this.open = true
      }, this.delay)
    },

    hide () {
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }

      this.open = false
    }
  }
})

export const TooltipToggleMixin = {
  props: {
    tooltip: {
      type: Object,
      default: null
    }
  }
}
